// Owner in P2: piece 16 "Lists and waves" (docs/FILE-OWNERSHIP.md).
// The feature's entry file (docs/CONTRACTS.md section 16): `/lists`, one lazy chunk. The selected list is the URL's `list` search
// value, a list id (ls_ or ml_) and nothing else, so the omnibar's /lists?list=<listId> selects a row (CONTRACTS.md 21.10).
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { ListChecks } from 'lucide-react'
import type { Feature } from '../feature.ts'
import { parseSearch } from './queries.ts'

export const feature: Feature = {
  app: (parent) => [
    createRoute({
      getParentRoute: () => parent,
      path: '/lists',
      validateSearch: (search: Record<string, unknown>) => parseSearch(search),
      component: lazyRouteComponent(() => import('./ListsScreen.tsx')),
    }),
  ],
  nav: [{ to: '/lists', label: 'nav.lists', icon: ListChecks, group: 'work', key: 'l' }],
}
